import { useEffect } from "react";
import { DashboardViewModel } from "../../viewmodels/dashboard/DashboardViewModel";
import {
  BuildingStorefrontIcon,
  PaperClipIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import { ClockIcon } from "@heroicons/react/20/solid";
import DashboardCard from "./DashboardCard";
import CardVacationRow from "./CardVacationRow";
import CardInformationRow from "./CardInformationRow";
import DashboardFormsCard from "./DashboardFormsCard";
import CardFormsRow from "./CardFormsRow";

function Dashboard(props) {
  const { logout } = props;
  const {
    fetchEmployeesForDashboard,
    fetchIncompleteAssignedDocuments,
    fetchStoresForDashboard,
    fetchVacationsForDashboard,
    employees,
    openDocuments,
    stores,
    vacations,
  } = DashboardViewModel(logout);

  useEffect(() => {
    fetchEmployeesForDashboard();
    fetchIncompleteAssignedDocuments();
    fetchStoresForDashboard();
    fetchVacationsForDashboard();
  }, []);

  return (
    <div className="my-10">
      <ul className="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-2 xl:gap-x-8">
        <DashboardFormsCard
          card={{
            name: "Incomplete Forms",
            icon: PaperClipIcon,
            iconForeground: "text-teal-700",
            iconBackground: "bg-teal-100",
            data: openDocuments,
            infoRow: CardFormsRow,
            mainHref: "/stores",
          }}
        />
        <DashboardCard
          card={{
            name: "Stores",
            icon: BuildingStorefrontIcon,
            iconForeground: "text-teal-700",
            iconBackground: "bg-teal-100",
            data: stores,
            infoRow: CardInformationRow,
            mainHref: "/stores",
          }}
        />
        <DashboardCard
          card={{
            name: "Employees",
            icon: UsersIcon,
            iconForeground: "text-sky-700",
            iconBackground: "bg-sky-50",
            data: employees,
            infoRow: CardInformationRow,
            mainHref: "/employees",
          }}
        />
        <DashboardCard
          card={{
            name: "Vacations",
            icon: ClockIcon,
            iconForeground: "text-teal-700",
            iconBackground: "bg-teal-100",
            data: vacations,
            infoRow: CardVacationRow,
            mainHref: "/vacation-requests",
          }}
        />
      </ul>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
